
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { apiPostRelate, PostItemProps } from ".";
import { loading, find, endLoading } from "store/post";

interface ApiPostFindByIdInputProps {
    id: number;
}

type ApiPostFindOutputProps = OutputBaseProps<{ item: PostItemProps; }, ApiPostFindByIdInputProps>

export const apiPostFindById = async (data: ApiPostFindByIdInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiPostFindOutputProps>(`/api/post/${data.id}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));

        if (res.data.item.topic?.id) {
            apiPostRelate({ page: 1, pageSize: 5, topicIds: [res.data.item.topic?.id] });
        }
    }
    else {
        store.dispatch(endLoading());
    }
    return res;
};


interface ApiPostFindByCodeInputProps {
    code: string;
}

export const apiPostFindByCode = async (data: ApiPostFindByCodeInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiPostFindOutputProps>(`/api/post/code/${data.code}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
        if (res.data.item.topic?.id) {
            apiPostRelate({ page: 1, pageSize: 5, topicIds: [res.data.item.topic?.id] });
        }
    }
    else {
        store.dispatch(endLoading());
    }
    return res;
};